module.exports = __webpack_public_path__ + "static/fonts/Admira-Font-Outline-34.addded0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Admira-Font-Outline-34.ttf
// module id = T828
// module chunks = 1